import { render, staticRenderFns } from "./InputHelper.vue?vue&type=template&id=23a4e99b&scoped=true&"
import script from "./InputHelper.vue?vue&type=script&lang=ts&"
export * from "./InputHelper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4e99b",
  null
  
)

export default component.exports